var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rewind",
    transform: "translate(0 0.638)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6743",
    "data-name": "Rectangle 6743",
    width: 33,
    height: 33,
    transform: "translate(0 -0.638)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64777",
    "data-name": "Path 64777",
    d: "M11.264,70.2l11.487-7.392a1.03,1.03,0,0,1,1.584.876V78.441a1.03,1.03,0,0,1-1.584.876L11.264,71.925a1.017,1.017,0,0,1,0-1.726Z",
    transform: "translate(-9.397 -54.755)",
    fill: "#32496b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64778",
    "data-name": "Path 64778",
    d: "M123.264,70.2l11.487-7.392a1.03,1.03,0,0,1,1.584.876V78.441a1.03,1.03,0,0,1-1.584.876l-11.487-7.392a1.017,1.017,0,0,1,0-1.726Z",
    transform: "translate(-106.974 -54.755)",
    fill: "#32496b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.65b452e8353b1c4340495c179830c8a2.svg";
export { ForwardRef as ReactComponent };